import { Injectable, signal } from '@angular/core';
import { Condominium } from '../../../../generated-sources/openapi/model/condominium';
import { House } from '../../../../generated-sources/openapi/model/house';

@Injectable({ providedIn: 'root' })
export class SearchStateService {
  condominiums = signal<Condominium[]>([]);
  houses = signal<House[]>([]);
  idCondominium = signal<number | null>(null);
  idHouse = signal<number | null>(null);

  setCondominiums(list: Condominium[]): void {
    this.condominiums.set(list);
  }

  setHouses(list: House[]): void {
    this.houses.set(list);
  }

  setCondominium(id: number | null): void {
    this.idCondominium.set(id);
    this.idHouse.set(null);
    this.houses.set([]);
  }

  setHouse(id: number | null): void {
    this.idHouse.set(id);
  }
}
